import SomethingWentWrongDialog from './SomethingWentWrongDialog';

export default SomethingWentWrongDialog;
